module.exports = __webpack_public_path__ + "static/media/4.902f83f9.svg";